module.exports = __webpack_public_path__ + "static/video_snapshot-570ce0950d99c4b2b4a84ff3928969a7.png";